import { useSalesOrderConfig } from '../../utils/FetchConfig';
import { IWorkspaceColumnOverride } from '../../@types/workspaceTypes';
import { useMemo } from 'react';

export const useAcknowledgedDeliveryDate = (): IWorkspaceColumnOverride => {
  const orderConfig = useSalesOrderConfig();

  return useMemo(() => {
    if (!orderConfig?.useAcknowledgedDeliveryDate) {
      return {
        acknowledgedDeliveryDate: {
          disabled: true,
        },
      };
    }
    return {};
  }, [orderConfig?.useAcknowledgedDeliveryDate]);
};
